<div class="ai-detail" *ngIf="analysis">
    <p class="ai-detail__summary text-secondary mat-small" *ngIf="analysis.structured?.attentionSummary">
        {{ analysis.structured.attentionSummary }}
    </p>

    <div class="ai-detail__section" *ngFor="let section of analysis.structured?.sections">
        <div class="ai-detail__section-title subtitle-3 text-primary-darker">{{ section.label }}</div>
        <p class="text-secondary mat-small" *ngIf="section.summary">{{ section.summary }}</p>
        <div class="ai-detail__field" *ngFor="let field of section.fields">
            <span class="ai-detail__field-label">{{ field.label }}:</span>
            <span class="text-secondary mat-small">{{ field.value }}</span>
        </div>
        <div class="ai-detail__score-card" *ngIf="section.score != null">
            <span class="subtitle-3">{{ 'modules.cases.evolutions.ai-review.score-label' | exp:'':'Puntaje' }}:</span>
            <span class="ai-detail__score-value">{{ section.score }}</span>
            <p class="text-secondary mat-small mts-1" *ngIf="section.scoreReason">
                {{ 'modules.cases.evolutions.ai-review.score-reason' | exp:'':'Motivo del puntaje' }}: {{ section.scoreReason }}
            </p>
        </div>
    </div>

    <button mat-button color="primary" class="mts-2" type="button" (click)="rate.emit()">
        {{ 'modules.cases.evolutions.ai-review.rate-evolution' | exp:'':'Calificar evolución' }}
    </button>
</div>
